module.exports = __webpack_public_path__ + "static/img/yytx02.c781042.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/details/QRcode/yytx02.png
// module id = 782
// module chunks = 0